import React, { useState, useEffect, useMemo } from 'react';
import { Input, Form, Button, Select, List, Switch, Typography, Modal, Alert } from 'antd';
import { Pie } from 'react-chartjs-2';
import api from '../service/index';
import { FileInputSingleApi } from '../components';
import { nanoid } from 'nanoid';

let QuestionInput = props => {
   let { question, setQuestion, disabled } = props;
   let surveyId = props.surveyId;
   let [questionChart, setQuestionChart] = useState(null);

   let setField = field => value => {
      setQuestion(
         {
            ...question,
            [field]: value
         });
   };

   let setChoiceField = i => field => value => {
      setField('choices')(
         question.choices.map((c, _i) => i === _i ? { ...c, [field]: value } : c)
      );
   };

   let addChoice = (choice) => {
      if (choice.media) {
         setField('choices')(question.choices.map(element => {
            if (element.id === choice.id) {
               element.urlName = choice.media.id
               element.media = choice.media
               element.name = choice.name
            }
            return element
         }))
      }
      else {
         setField('choices')(
            [...question.choices, {
               id: nanoid(20),
               name: '',
               media: {
                  id: "",
                  thumb: "",
                  url: "",
                  type: "",
                  mimeType: ""
               }
            }]
         );
      }
   };



   let deleteChoice = i => {
      setField('choices')(
         question.choices.filter((c, _i) => _i !== i)
      );
   };

   return <div style={{ border: '1px solid #ccc', borderRadius: 5, width: 800, padding: 10 }}>
      <div style={{ display: 'block', marginBottom: 10 }}>
         <Button style={{ float: 'right', zIndex: 10 }} type="danger" disabled={disabled}
            onClick={props.delete}>Soruyu Sil</Button>
      </div>
      
      <Form.Item label="Soru Tipi" required={true}>
         <Select value={question.type} onChange={setField('type')} disabled={disabled}>
            <Select.Option value="TextToText">Metin Soru - Metin Şık</Select.Option>
            <Select.Option value="TextToImage">Metin Sorusu - Resim Şık</Select.Option>
            <Select.Option value="ImageToText">Resim Soru - Metin Şık</Select.Option>

         </Select>
      </Form.Item>

      {question.type === "ImageToText" &&
         <Form.Item label="Soru Resmi" required={true}>
            <FileInputSingleApi className="button4" record={question} setRecord={setQuestion} name="media" fileName="questionSet" />
            <Alert type="info" message="Kare görsel olmalıdır." banner />
         </Form.Item>
      }
      
      <Form.Item label="Soru Metni" required={true}>
         <Input.TextArea value={question.name} multiple={true} style={{ width: 750, height: 100 }}
            disabled={disabled}
            onChange={e => setField('name')(e.target.value)} />
      </Form.Item>


      <div style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 15 }}>
         <Typography.Text strong>Seçenekler</Typography.Text>
         <Button style={{ float: 'right' }} onClick={addChoice} disabled={disabled}>Seçenek Ekle</Button>
      </div>
      <List>
         {question.choices.map((c, i) =>
            <List.Item key={i} style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
               <div style={{ marginRight: 5 }}>{i + 1}.</div>

               {question.type !== "TextToImage" &&
                  <div>
                     <Input style={{ width: 350, marginLeft: 2, display: 'flex', alignItems: 'center' }} disabled={disabled}
                        value={c.name} onChange={e => setChoiceField(i)('name')(e.target.value)} />
                  </div>
               }

               {question.type === "TextToImage" &&
                  <div>
                     <FileInputSingleApi className="button4" record={c} setRecord={addChoice} name="media" fileName="questionSet" />
                     <Alert type="info" message="Kare görsel olmalıdır." banner />
                  </div>
               }

               <div style={{ display: 'flex', justifyContent: 'space-between', float: 'right', minWidth: '20%' }}>
                  <div style={{ marginLeft: 10, display: 'flex', alignItems: 'center' }}>
                     <Switch style={{ marginLeft: 5, float: 'right' }} checked={c.correctAnswer}
                        disabled={disabled} checkedChildren="Doğru" unCheckedChildren="Yanlış"
                        onChange={value => setChoiceField(i)('correctAnswer')(value)} />
                  </div>
                  <div style={{ marginLeft: 10, float: 'right' }}>
                     <Button type="danger" shape="circle" disabled={disabled}
                        onClick={() => deleteChoice(i)}>Sil</Button>
                  </div>
               </div>
            </List.Item>)}
      </List>
   </div>;
};

export default (props) => {
   let { record, setRecord, name, disabled } = props;
   let questions = record[name];
   let [page, setPage] = useState(0);

   let addQuestion = () => {
      setRecord({
         ...record,
         questions: [...(questions ? questions : []), {
            id: nanoid(20),
            name: '',
            type: 'TextToText',
            choices: [],
            media: {
               id: "",
               thumb: "",
               url: "",
               type: "",
               mimeType: ""
            },
         }]
      });
      setPage(questions ? questions.length : 0);
   };



   return <Form.Item >
      <div style={questions && questions.length > 0 ? { width: 800 } : { display: 'flex' }}>
         {questions && questions.map((q, i) =>
            <Button key={i} shape="circle" type={(i === page) ? 'primary' : 'dashed'}
               onClick={() => setPage(i)} style={{ marginRight: 5, marginBottom: 10 }} >
               {i + 1}
            </Button>)}
         <Button type="primary" disabled={disabled} style={{ float: 'right' }}
            onClick={addQuestion}>Soru Ekle</Button>
      </div>

      {questions && questions.map((q, i) => i === page &&
         <QuestionInput key={i} question={q} disabled={disabled}
            surveyId={record._id}
            setQuestion={newQ => setRecord({
               ...record,
               questions: questions.map((_q, _i) => _i === i ? newQ : _q)
            })}
            delete={() => {
               setPage(page - 1)
               setRecord({
                  ...record,
                  questions: questions.filter((_q, _i) => _i !== i)
               })
            }} />)}
   </Form.Item>;
};

